import { useCompany, useCompanyBookings } from "@/api";
import { WELCOME_BOOKING_URL } from "@/lib";
import { createFileRoute } from "@tanstack/react-router";
import { Trans, useTranslation } from "react-i18next";
import { useWelcomeBookingAccess } from "@/hooks/useWelcomeBookingAccess";
import BookingAdminView from "@/components/bookings/BookingAdminView";
import { useCompanyAdminAccess } from "@/hooks/useCompanyAdminAccess";

export const Route = createFileRoute("/_portal/company/$companyId/bookings/")({
  component: CompanyBookings,
});

function CompanyBookings() {
  const { t, i18n } = useTranslation();
  const { companyId } = Route.useParams();
  const { allowWelcomeBookingAccess } = useWelcomeBookingAccess();
  const { data: company } = useCompany(companyId);
  const { allowCompanyAdminAccess } = useCompanyAdminAccess(companyId);

  if (!allowCompanyAdminAccess || !allowWelcomeBookingAccess) return null;
  return (
    <>
      <div className="pageHeader">
        <h1>{t("PAGES.COMPANY_BOOKING.HEADER")}</h1>
        <p>
          <Trans
            i18nKey="PAGES.COMPANY_BOOKING.SUBHEADER"
            values={{ companyName: company.buildingTenantName }}
          >
            Text
            <a href={WELCOME_BOOKING_URL(i18n.language)} target="_blank">
              link
            </a>
            .
          </Trans>
        </p>
      </div>
      <BookingAdminView
        companyId={companyId}
        newBookingPath={`/company/${companyId}/bookings/new`}
        getBookingsFn={useCompanyBookings}
      />
    </>
  );
}
